import React, { useMemo } from 'react';
import { Box, Hint, HintText, Text } from '@common-fe/common-fe';

import BannerItem from '../../BannerItem';
import { BannerReplenishmentPreviewProps } from '../BannerReplenishmentPreview.types';

import BannerCurrentInvoice from './BannerCurrentInvoice';
import BannerPreviousInvoice from './BannerPreviousInvoice';
import BannerReplenishmentFilterDropdown from './BannerReplenishmentFilterDropdown';
import { StyledTitle } from './BannerReplenishmentPreview.styles';

export const BannerReplenishmentPreview: React.FC<BannerReplenishmentPreviewProps> = ({
  isLoading,
  data,
  planIds,
  planValue,
  onSetPlanValue,
  subsidiaryValue,
  onSetSubsidiaryValue,
}) => {
  const isPreviousInvoiceShowed = useMemo(() => {
    return Boolean(data?.previousInvoiceDate) && data?.previousInvoiceAmount != null;
  }, [data?.previousInvoiceAmount, data?.previousInvoiceDate]);
  return (
    <Box
      data-testid="dashboard_banner_replenishment-preview"
      style={{ flex: 1 }}
      margin={{ right: 'spacing24' }}
    >
      <BannerItem
        height="250px"
        style={{ zIndex: 4 }}
        direction="column"
        align="stretch"
        justify="start"
        pad="spacing16"
      >
        <Box direction="column">
          <Hint
            hintWidth={240}
            hintHeight={150}
            hintElement={
              <Box>
                <HintText>
                  <StyledTitle
                    data-testid="dashboard_banner_replenishment-preview_title"
                    color="textOnColor"
                    size="medium"
                    weight={700}
                  >
                    Replenishment Preview
                  </StyledTitle>
                </HintText>
              </Box>
            }
          >
            <Text
              data-testid="dashboard_banner_replenishment-preview_title_hint"
              textAlign="center"
              size="small"
            >
              This is a forecast of your next replenishment. It shows your current claim spend, which is the
              amount that will be invoiced on the next invoice date.
            </Text>
          </Hint>

          <Box direction="row" justify="end" pad={{ top: 'spacing8', bottom: 'spacing4' }}>
            <BannerReplenishmentFilterDropdown
              isLoading={isLoading}
              planIds={planIds}
              planValue={planValue}
              onSetPlanValue={onSetPlanValue}
              subsidiaryValue={subsidiaryValue}
              onSetSubsidiaryValue={onSetSubsidiaryValue}
            />
          </Box>
        </Box>

        <Box direction="column" justify="between" gap="spacing2" style={{ flex: 1 }}>
          <BannerCurrentInvoice isLoading={isLoading} value={data?.currentInvoiceAmount || 0} />

          {isPreviousInvoiceShowed && data?.previousInvoiceDate && (
            <BannerPreviousInvoice
              invoiceId={data.previousInvoiceId}
              date={data.previousInvoiceDate}
              amount={data.previousInvoiceAmount}
            />
          )}
        </Box>
      </BannerItem>
    </Box>
  );
};

export default BannerReplenishmentPreview;
